import { useEffect, useRef } from 'react';

export default function ServiceCard({ num, title, desc, variant = '', img }) {
  const ref = useRef(null);

  useEffect(() => {
    const card = ref.current;
    if (!card) return;
    const onMove = (e) => {
      const r = card.getBoundingClientRect();
      const x = (e.clientX - r.left) / r.width - 0.5;
      const y = (e.clientY - r.top)  / r.height - 0.5;
      card.style.transform = `perspective(1000px) rotateX(${-y * 7}deg) rotateY(${x * 7}deg)`;
    };
    const onLeave = () => { card.style.transform = 'perspective(1000px) rotateX(0) rotateY(0)'; };
    card.addEventListener('mousemove', onMove);
    card.addEventListener('mouseleave', onLeave);
    return () => { card.removeEventListener('mousemove', onMove); card.removeEventListener('mouseleave', onLeave); };
  }, []);

  // Derivar classes CSS do variant string
  const classes = `svc ${variant}`;

  return (
    <div className={classes} ref={ref}>
      <div className="svc-head">
        <span className="num">{num}</span>
        <span className="arr">↗</span>
      </div>
      <div className="svc-body">
        <h3>{title}</h3>
        <p>{desc}</p>
      </div>
      {img && (() => {
        const isLocal = img.startsWith('/');
        return (
          <div className={`svc-img${isLocal ? ' is-illustration' : ''}`}>
            <img
              src={img}
              alt={title}
              loading="lazy"
              decoding="async"
              {...(isLocal ? {} : { width: 900, height: 600 })}
            />
          </div>
        );
      })()}
    </div>
  );
}
